import React, { useState, useEffect } from "react";
import { Container, Typography, CircularProgress, Grid } from "@mui/material";
import axios from "axios";
import configuration from "../config.js";
import Layout from "../components/layout/InvoiceLayout.jsx";
import { useSelector } from "react-redux";
import ProductFlashCard from "../components/productFlashCard.jsx";

const InvoiceProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { API_BASE_URL } = configuration;
  const selectedCompanyId = useSelector((state) => state.kyc.selectedCompanyId);

  useEffect(() => {
    if (selectedCompanyId) {
      fetchProducts();
    } else {
      setLoading(false);
    }
  }, [selectedCompanyId]); 

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/getInventory/${selectedCompanyId}`
      );
      
      let productsData = response.data;
      
      if (!Array.isArray(productsData)) {
        if (productsData && typeof productsData === 'object') {
          
          if (Array.isArray(productsData.data)) {
            productsData = productsData.data;
          } else if (Array.isArray(productsData.products)) {
            productsData = productsData.products;
          } else if (Array.isArray(productsData.inventory)) {
            productsData = productsData.inventory;
          } else {
            if (productsData._id || productsData.name || productsData.price) {
              productsData = [productsData]; 
            } else {
              const possibleArray = Object.values(productsData).filter(item => 
                item && typeof item === 'object'
              );
              if (possibleArray.length > 0) {
                productsData = possibleArray;
              } else {
                productsData = [];
                console.warn("Couldn't extract products from response:", response.data);
              }
            }
          }
        } else {
          productsData = [];
          console.warn("Received unexpected data format:", response.data);
        }
      }
      
      setProducts(productsData);
      setLoading(false);
      setError(null);
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Failed to fetch products. Please try again later.");
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography variant="h6" color="error">
          Error: {error}
        </Typography>
      </Container>
    );
  }

  const productsArray = Array.isArray(products) ? products : [];

  return (
    <Layout>
      <Container>
        <Typography variant="h4" gutterBottom>
          Invoice Products
        </Typography>
        
        {productsArray.length === 0 ? (
          <Typography variant="body1">No products found.</Typography>
        ) : (
          <Grid container spacing={2}>
            {productsArray.map((product, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={product._id || `product-${index}`}>
                <ProductFlashCard product={product} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Layout>
  );
};

export default InvoiceProducts;